/**
 * A/Bテストの実験名。
 *
 * この文字列は群分けハッシュのソルトになる。実験ごとに必ず別の値にすること。
 * 同じ値を使い回すと、別の実験と群が完全に一致して効果が混ざる。
 *
 * 集計時に BigQuery 側で同じ群を復元するため、**一度公開した実験名は変更しない**。
 * 変更すると全ユーザーの群が入れ替わり、それまでのデータが使えなくなる。
 */

/**
 * 好み選択オンボーディングの効果検証。
 *
 * 3群に割る。オンボーディング単体の効果とメッセージ一覧の絞り込み単体の効果を
 * 分離して読むため、実験を2つに分けず1つのハッシュを3分割する
 * （`~/lib/preferenceOnboardingExperiment`）。
 */
export const PREFERENCE_ONBOARDING_EXPERIMENT = "pref_onboarding_2026_09";
